<div class="bg-brand-surface-raised flex items-center justify-center min-h-screen p-4">
  <div class="w-full max-w-[88%] flex flex-col lg:flex-row gap-15">
    <!-- Sección izquierda con ícono central grande y texto original -->
    <div
      class="relative w-full lg:w-1/2 rounded-3xl shadow-md h-auto lg:h-[90vh] overflow-hidden
             bg-[radial-gradient(circle_at_top_left,_#3366FF_0%,_#16173A_70%,_#16173A_100%)]"
    >
      <img
        src="/assets/icons/Auth/Blurring_lock.svg"
        alt="Blurring Lock Icon"
        class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
               h-[720px] w-[720px] opacity-80"
      />

      <div class="relative z-10 p-8 lg:p-12 flex flex-col items-start">
        <h1 class="text-white font-bold leading-tight text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
          Protege tu<br />
          Firma<br />
          <span class="text-blue-300">Hoy</span>
        </h1>
      </div>
    </div>

    <!-- Sección derecha para definir la nueva contraseña -->
    <div
      class="w-full lg:w-1/2 bg-white rounded-3xl shadow-md h-auto lg:h-[90vh] flex items-center justify-center"
    >
      <div class="w-full max-w-xl px-12 py-16">
        <div class="flex justify-start mb-6">
          <div class="bg-blue-50 rounded-full p-4">
            <img
              src="/assets/icons/Auth/Padlock.svg"
              alt="Padlock Icon"
              class="h-12 w-12"
            />
          </div>
        </div>

        <h2 class="text-5xl font-bold text-gray-800 mb-4">Define tu nueva contraseña</h2>
        <p class="text-lg text-gray-600 mb-12">
          Ingresa una contraseña segura para continuar.
        </p>

        <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="space-y-10">
          <div>
            <label class="block text-lg font-medium text-gray-700 mb-2">Nueva contraseña</label>
            <div class="relative">
              <input
                [type]="showNewPassword ? 'text' : 'password'"
                formControlName="newPassword"
                autocomplete="new-password"
                class="block w-full px-4 py-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-lg"
                placeholder="Ingresa una nueva contraseña"
              />
              <button
                type="button"
                (click)="toggleNewPasswordVisibility()"
                class="absolute inset-y-0 right-0 flex items-center z-20 px-4 text-gray-400 hover:text-blue-600"
                [attr.aria-label]="showNewPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
              >
                <svg class="shrink-0 w-5 h-5" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <ng-container *ngIf="showNewPassword; else newEyeClosed">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                    <circle cx="12" cy="12" r="3" />
                  </ng-container>
                  <ng-template #newEyeClosed>
                    <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                    <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
                    <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                    <line x1="2" x2="22" y1="2" y2="22" />
                  </ng-template>
                </svg>
              </button>
            </div>
            <div class="mt-2 rounded-lg border border-blue-100 bg-blue-50 px-3 py-2 text-xs text-blue-800">
              Tu contraseña debe incluir:
              <ul class="list-disc pl-5 mt-1 space-y-0.5">
                <li>Mínimo 8 caracteres.</li>
                <li>Al menos una letra mayúscula.</li>
                <li>Al menos una letra minúscula.</li>
                <li>Al menos un número.</li>
                <li>Al menos un símbolo.</li>
              </ul>
            </div>
            <p *ngIf="submitted && f['newPassword'].hasError('pattern')" class="text-xs text-red-600 mt-1">
              Mínimo 8 caracteres, con mayúscula, minúscula, número y símbolo.
            </p>
          </div>

          <div>
            <label class="block text-lg font-medium text-gray-700 mb-2">Confirmar contraseña</label>
            <div class="relative">
              <input
                [type]="showConfirmPassword ? 'text' : 'password'"
                formControlName="confirmPassword"
                autocomplete="new-password"
                class="block w-full px-4 py-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-lg"
                placeholder="Repite tu nueva contraseña"
              />
              <button
                type="button"
                (click)="toggleConfirmPasswordVisibility()"
                class="absolute inset-y-0 right-0 flex items-center z-20 px-4 text-gray-400 hover:text-blue-600"
                [attr.aria-label]="showConfirmPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
              >
                <svg class="shrink-0 w-5 h-5" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <ng-container *ngIf="showConfirmPassword; else confirmEyeClosed">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                    <circle cx="12" cy="12" r="3" />
                  </ng-container>
                  <ng-template #confirmEyeClosed>
                    <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                    <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
                    <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                    <line x1="2" x2="22" y1="2" y2="22" />
                  </ng-template>
                </svg>
              </button>
            </div>
          </div>

          <div>
            <button
              type="submit"
              [disabled]="loading"
              class="w-full flex justify-center py-5 px-6 border border-transparent rounded-lg shadow-sm
                     text-xl text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-70"
            >
              Continuar con código
            </button>
          </div>

          <div *ngIf="successMessage" class="text-green-600 text-center text-lg">
            {{ successMessage }}
          </div>
          <div *ngIf="errorMessage" class="text-red-600 text-center text-lg">
            {{ errorMessage }}
          </div>

          <div class="mt-8 text-center">
            <button
              type="button"
              (click)="goToLogin()"
              class="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700
                     bg-white hover:bg-gray-50 rounded-md font-medium focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              <svg xmlns="http://www.w3.org/2000/svg"
                   class="h-5 w-5 mr-2 text-gray-600"
                   fill="none"
                   viewBox="0 0 24 24"
                   stroke="currentColor"
                   stroke-width="2"
              >
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
              Volver al inicio de sesión
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
